import { jsx } from "react/jsx-runtime";
import { formatMinorUnits } from "@seek/currency";
import { useTranslations } from "@vocab/react";
import { Box, Stack, Text } from "braid-design-system";
import { translations } from "../../../../HirerOrderSummary/components/.vocab/index.mjs";
import { OrderTableRow } from "../OrderTableRow/OrderTableRow.mjs";
import { subTotal } from "./SubTotal.css.mjs";
const SubTotal = ({ subTotal: subTotal$1 = 0, tax, surcharge = 0, currency, language }) => {
  var _a;
  const { t } = useTranslations(translations);
  const items = [
    [t("sub total..."), subTotal$1],
    [tax == null ? void 0 : tax.code, ((_a = tax == null ? void 0 : tax.amount) == null ? void 0 : _a.value) ?? 0],
    [t("surcharge..."), surcharge]
  ];
  return /* @__PURE__ */ jsx(
    Box,
    {
      className: subTotal,
      background: "neutralLight",
      paddingX: "medium",
      paddingY: "medium",
      children: /* @__PURE__ */ jsx(Stack, { space: "medium", children: items.filter(([title, price]) => title && price > 0).map(([title, price]) => /* @__PURE__ */ jsx(
        OrderTableRow,
        {
          left: /* @__PURE__ */ jsx(Text, { weight: "medium", children: title }),
          right: /* @__PURE__ */ jsx(Text, { align: "right", weight: "medium", children: formatMinorUnits(price, {
            currency,
            locale: language
          }) })
        },
        title
      )) })
    }
  );
};
export {
  SubTotal
};
